import { Moon, Sun } from "lucide-react";
import { cn } from "@/lib/utils";
import { useTheme } from "./theme-provider";

export interface ThemeToggleProps {
  className?: string;
  label?: string;
}

export function ThemeToggle({
  className,
  label = "Toggle color scheme",
}: ThemeToggleProps) {
  const { resolvedScheme, toggleScheme } = useTheme();
  const isLight = resolvedScheme === "light";

  return (
    <button
      type="button"
      role="switch"
      aria-checked={isLight}
      aria-label={label}
      onClick={toggleScheme}
      className={cn("theme-toggle", className)}
      data-scheme={resolvedScheme}
    >
      <span className="toggle-track" aria-hidden="true">
        <span className="toggle-thumb">
          {isLight ? <Sun size={14} /> : <Moon size={14} />}
        </span>
      </span>
    </button>
  );
}

export interface AccessibleToggleProps {
  className?: string;
  label?: string;
}

export function AccessibleToggle({
  className,
  label = "Toggle accessible mode",
}: AccessibleToggleProps) {
  const { accessible, toggleAccessible } = useTheme();

  return (
    <button
      type="button"
      role="switch"
      aria-checked={accessible}
      aria-label={label}
      onClick={toggleAccessible}
      className={cn("theme-toggle theme-toggle-accessible", className)}
      data-accessible={accessible ? "true" : "false"}
    >
      <span className="toggle-track" aria-hidden="true">
        <span className="toggle-thumb" />
      </span>
    </button>
  );
}
